import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AboutPageComponents/OurManagementPage/MangementSection/MangementSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/FooterCard/FooterCard.tsx");
